module.exports = __webpack_public_path__ + "img/20250521_manavisfesta_02.3327af42.jpg";